module.exports = __webpack_public_path__ + "static/media/teen_awareness-dt-fr.945dec56.jpg";